import { createTheme } from '@material-ui/core/styles';

// Nothing yet..
const theme = {};

export default createTheme(theme);